import axios from "axios";
import { refreshAccessToken } from "config/token";
import { IMsalContext } from "@azure/msal-react";
import { Modal } from "antd";

let isRefreshing = false;
let failedQueue: Array<{
  resolve: (value?: unknown) => void;
  reject: (reason?: unknown) => void;
}> = [];

const processQueue = (error: unknown, token: string | null = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

export function axiosIntercept(msalInstance: IMsalContext): void {
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalReq = error.config;
      if (error.response && error.response.status === 403 && error?.response?.data?.detail?.toLowerCase().includes("token is expired")) {
        // Handle expired token - attempt to refresh
        
        if (isRefreshing) {
          // If token is already being refreshed, queue this request
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              const bearerToken = "Bearer " + (token === undefined ? "" : String(token));
              const config = {
                headers: { "Authorization": bearerToken },
              };

              if (originalReq.method === "post") {
                const data = JSON.parse(originalReq.data);
                return axios.post(originalReq.url, data, config);
              }
              if (originalReq.method === "get") {
                return axios.get(originalReq.url, config);
              }
            })
            .catch((err) => {
              return Promise.reject(err instanceof Error ? err : new Error(String(err)));
            });
        }

        isRefreshing = true;
        
        try {
          const newToken = await refreshAccessToken(msalInstance);
          const bearerToken = "Bearer " + (newToken === undefined ? "" : (newToken.token || ""));
          const config = {
            headers: { "Authorization": bearerToken },
          };

          isRefreshing = false;
          processQueue(null, newToken?.token || null);

          if (originalReq.method === "post") {
            const data = JSON.parse(originalReq.data);
            return await axios.post(originalReq.url, data, config);
          }
          if (originalReq.method === "get") {
            return await axios.get(originalReq.url, config);
          }
        } catch (error) {
          isRefreshing = false;
          processQueue(error, null);
          
          // Token refresh failed - show session expired modal
          Modal.error({
            title: "Session Expired",
            content: "Your session has expired. Please log in again to continue.",
            okText: "Login",
            centered: true,
            onOk: () => {
              window.location.reload();
            },
          });
          
          return Promise.reject(error instanceof Error ? error : new Error(String(error)));
        }
      } else {
        // Non-401 error or other error - propagate to calling code
        return Promise.reject(error instanceof Error ? error : new Error(String(error)));
      }
    },
  );
}
